var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"300","opacity":"0.95"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"original","size":"120"}},[_c('v-img',{attrs:{"src":require("../assets/icon_color.png"),"width":"80"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }